export const isValidImage = (page) => {
  return page.promo_image.content && JSON.parse(page.promo_image.content).url;
};
